const init = 0;

const reducer = (state = init, action) => {
  switch (action.type) {
    case 'CREDIT':
      return action.value;
  
    default: return state;
  }
}


export default reducer;